
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.065 6.586L5.763 3.29a.583.583 0 10-.828.822L7.822 7.03 4.935 9.916a.583.583 0 00.19.952.584.584 0 00.449 0 .583.583 0 00.19-.13l3.3-3.295a.583.583 0 000-.857z","fill":"currentColor"}})])
          )
        }
      }
    